<template>
  <v-card class="mt-6">
    <TitleModal 
      v-model="showEditTitleModal"
      :titles="titles"
      :title="title"
      :create="false"
      @save="saveTitle"
    />
    <v-btn
      dark
      small
      absolute
      top
      right
      fab
      color="red"
      @click="deleteTitle"
    >
      <v-icon>mdi-delete</v-icon>
    </v-btn>
    <v-card-text>
      <v-select
        :value="title.title_id"
        :items="titles"
        label="Title"
        item-value="id"
        item-text="name"
        class="pt-2"
        outlined
        disabled
        dense
        hide-details
      />
      <v-text-field
        :value="title.url"
        label="Url"
        class="pt-2"
        outlined
        disabled
        dense
        hide-details
      />
      <v-tabs 
        v-model="tab"
      >
        <v-tab>Banner</v-tab>
        <v-tab>Play more</v-tab>

        <v-tab-item :value="0">
          <Banner
            :title="title"
          />
        </v-tab-item>
        <v-tab-item :value="1">
          <PlayMore
            :title="title"
          />
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import TitleModal from './TitleModal';
import Banner from './Banner';
import PlayMore from './PlayMore';

export default {
  props: {
    titles: {
      type: Array,
      required: true
    },
    title: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  components: {
    TitleModal,
    Banner,
    PlayMore
  },
  data() {
    return {
      showEditTitleModal: false,
      tab: 0
    }
  },
  computed: {
    images() {
      return this.title.images.map(image => ({ ...image, src: this.addUuid(image.src) }))
    }
  },
  methods: {
    saveTitle(title) {
      this.$emit('edit', title, this.index)
    },
    deleteTitle() {
      this.$emit('delete', this.title, this.index)
    },
  },
}
</script>